(function ($, window) {
    "use strict";

    DSV.ui.newslist = {
        displayItems: function (items, num){
            this.dom.newslist.querySelectorAll('li')[num].classList.add('initialized');

            setTimeout( () => {
                if(num + 1 < items.length) {
                    this.displayItems(items, num + 1);
                }
            }, 100 );
        },

        renderItems: function(itemArray) {
            if (!Array.isArray(itemArray)) {
                return '';
            }

            //always empty list before showing new results
            this.dom.newslist.innerHTML = "";
            TweenLite.to(this.dom.newslist, 0, {opacity: 1});

            const itemNumMax = this.responseLength;
            let items = [];

            for (let i = 0, l = itemNumMax; i < l; i += 1) {
                const itemData = itemArray[i];
                const markup = `<li class="newslist__item">
                                    <a href="${itemData.Url}">
                                        <h3>${itemData.Headline}</h3>
                                        <p>${itemData.Manchet}</p>
                                        <date>${itemData.Date}</date>
                                    </a>
                                </li>`;


                items.push(markup);
                this.dom.newslist.insertAdjacentHTML('beforeend', markup);
            }

            this.displayItems(items, 0);
        },

        //display error if fetch fails
        displayErrorMessage(message){
            this.dom.newslist.innerHTML = message;
        },

        // this renders the loader on the bottom of the list and also handles it's removal.
        renderLoader(status) {
            if (status) {
                const markup = `
                                <div class="module-loader">
                                    <div class="module-loader--spinner"></div>
                                </div>`;

                this.dom.newslistLoader.insertAdjacentHTML('afterbegin', markup);
            } else {
                this.dom.newslistLoader.innerHTML = "";
            }
        },

        loadData: function(){
            this.renderLoader(true);

            const from = this.currentPage * this.pageSize;

            fetch(`${this.apiUrl}?datasourceId=${this.dataSource}&from=${from}&numberofnews=${this.pageSize}`)
                .then(response => response.json())
                .then(json => {
                    this.newsItem = json.NewsItems;
                    this.responseLength = this.newsItem.length;
                    this.totalNews = json.TotalCount || 20;
                    this.numberOfPages = Math.ceil(this.totalNews / this.pageSize);
                    this.renderLoader(false);
                    this.renderItems(this.newsItem);


                    if(this.dom.pagination && this.totalNews > this.pageSize) {
                        this.dom.pagination.innerHTML = "";
                        this.dom.pagination.appendChild(DSV.ui.pagination.renderPagination(this.numberOfPages, Number(this.currentPage)));
                        this.bindPaginationEvents();
                    }
                })
                .catch(error => {
                    this.renderLoader(false);
                    this.displayErrorMessage("Sorry. There seems to be an error loading news. Please try again");
                    window.console.error(error)
                })
        },

        updateQueryStringParameter: function (uri, key, value) {
            const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            const separator = uri.indexOf('?') !== -1 ? "&" : "?";

            if (uri.match(re)) {
                return uri.replace(re, '$1' + key + "=" + value + '$2');
            }
            else {
                return uri + separator + key + "=" + value;
            }
        },

        bindPaginationEvents: function() {
            const self = this;
            this.dom.paginationLinks = document.querySelectorAll('.pagination__link');

            for (let i = 0; i < this.dom.paginationLinks.length; i++) {
                this.dom.paginationLinks[i].addEventListener('click', (event) => {
                    event.preventDefault();

                    switch(i) {
                        case 0:
                            if (this.currentPage > 0) {
                                this.currentPage -= 1;
                            }
                            break;
                        case this.dom.paginationLinks.length - 1:
                            if (this.currentPage < this.numberOfPages - 1) {
                                this.currentPage += 1;
                            }
                            break;
                        default:
                            this.currentPage = Number(this.dom.paginationLinks[i].getAttribute('data-page'));
                    }

                    const updatedUrl = this.updateQueryStringParameter(window.location.href,'page', Number(this.currentPage + 1));
                    window.history.replaceState('','page', updatedUrl);

                    TweenLite.to(window, 0, {scrollTo:{y:this.dom.container, offsetY:100}});
                    TweenLite.to(this.dom.newslist, 0, {opacity: 0, onComplete: self.loadData, onCompleteScope: self});
                });
            }
        },

    init: function(container) {
            this.dom = {};
            this.dom.container = DSV.DOM.newslist;
            this.dom.newslist = document.querySelector('.newslist__list');
            this.dom.newslistLoader = document.querySelector('.newslist__loader');
            this.dom.pagination = document.querySelector('.newslist__pagination');
            this.pageSize = this.dom.newslist.getAttribute('data-pagesize') || 5;
            this.serviceUrl = this.dom.newslist.getAttribute('data-service-url');
            this.dataSource = this.dom.newslist.getAttribute('data-datasource');
            this.hostUrl = window.location.protocol + '//' + window.location.host;

            if( DSV.tools.getUrlParams('page') ) {
                this.currentPage = Number(DSV.tools.getUrlParams('page')) - 1;
            } else {
                this.currentPage = 0;
            }

            this.apiUrl =
                this.hostUrl +
                '/' +
                this.serviceUrl;

            this.loadData();
        }
    };
})(jQuery, window);